import React from 'react';

import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import './styles.scss';

const OlcPageBackButton = ({ children, className = '', ...props }) => (
  <Button
    {...props}
    className={`olcPageBackButton ${className}`.trim()}
    disableRipple
    startIcon={<ArrowBackIcon />}
  >
    {children}
  </Button>
);

export default OlcPageBackButton;
